import createEnvironments from './endpoints';

export const environment = {
  ...createEnvironments('https://nash-ir-test.ir-digital.net', 'https://iotgatet01.seepex.com', 'https://monitoring.seepex.com'),
  production: false,
  envname: 'development',
};
